import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import moment from 'moment-timezone'
import Button from '../../sitewide/Button'
import css from './MessageShutoff.css'

const styles = {
  block: {
    maxWidth: 250,
  },
  radioButton: {
    marginBottom: 16,
  },
}

class MessageShutoff extends Component {
  constructor(props) {
    super(props)

    this.state = {
      suspend: null,
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  handleChange(event, value) {
    this.setState({
      suspend: value === 'yes',
    })
  }

  handleClick() {
    if (this.state.suspend) {
      this.props.handleShutoff()
      this.props.handleSendMessage()
    } else {
      this.props.handleSendMessage()
    }
  }

  generateShutoffMessage({ doctor, location, blastMessageDateRange }) {
    return (
      `Should I leave reminders on for appointments with
      ${doctor.length === 0 ? 'all doctors' : doctor[0].preferred_name} at
      ${location.length === 0 ? 'all locations' : `the ${location[0].name} location`}
      from ${moment(blastMessageDateRange[0]).format('MMM D')} to ${moment(blastMessageDateRange[1]).format('MMM D')}?`
    )
  }

  generateDisclaimerMessage() {
    return 'Note: If you previously disabled reminders for this group of appointments, re-enabling them will require you to contact Support.'
  }

  render() {
    const { close, isSendingBlastMsg } = this.props
    return (
      <div className={css.modal}>
        <div
          role="button"
          className={css.close}
          tabIndex="0"
          onClick={close}
        />
        <div className={css.header}>Send this Message to Target Group</div>
        <p>
          {
            this.generateShutoffMessage(this.props)
          }
        </p>
        <p className={css.disclaimer}>
          {
            this.generateDisclaimerMessage()
          }
        </p>
        <RadioButtonGroup name="suspend?" onChange={this.handleChange}>
          <RadioButton
            value="no"
            label="Leave reminders on"
            style={styles.radioButton}
            color="white"
          />
          <RadioButton
            value="yes"
            label="Turn reminders off"
          />
        </RadioButtonGroup>
        <br />
        <Button
          onClick={this.handleClick}
          disabled={this.state.suspend == null || isSendingBlastMsg}
        >
          SEND THE MESSAGE
        </Button>
      </div>
    )
  }
}

MessageShutoff.propTypes = {
  close: PropTypes.func.isRequired,
  doctor: PropTypes.arrayOf(PropTypes.object).isRequired,
  location: PropTypes.arrayOf(PropTypes.object).isRequired,
  blastMessageDateRange: PropTypes.arrayOf(PropTypes.string).isRequired,
  handleSendMessage: PropTypes.func.isRequired,
  handleShutoff: PropTypes.func.isRequired,
  isSendingBlastMsg: PropTypes.bool.isRequired,
}

export default MessageShutoff



// WEBPACK FOOTER //
// ./src/components/Messages/Blasts/MessageShutoff.js